module.exports = __webpack_public_path__ + "static/media/left8.32f0247f.png";